<div class="school-class-compare-block-trophies" *ngIf="data" #mainEl [ngStyle]="{'--currentSlide': currentSlide, '--slidesPerView': slidesPerView}">
  <div class="school-class-compare-block-trophies__navigation" *ngIf="data.length > 2">
    <div class="school-class-compare-block-trophies__navigation-button prev" (click)="prevSlide()" [ngClass]="{'visible': isPrevButtonVisible}">
      <brt-icon [icon]="'reg-chevron-left'"></brt-icon>
    </div>
    <div class="school-class-compare-block-trophies__navigation-button next" (click)="nextSlide()" [ngClass]="{'visible': isNextButtonVisible}">
      <brt-icon [icon]="'reg-chevron-right'"></brt-icon>
    </div>
  </div>
  <div class="school-class-compare-block-trophies__scrollable-area">
    <div class="school-class-compare-block-trophies__class-wrapper" *ngFor="let classData of data">
      <div class="school-class-compare-block-trophies__class-headline">
        <span>{{classData.className}}</span>
        <span>{{classData.completedTrophiesNumber}} von {{classData.totalTrophiesNumber}} gesammelt</span>
      </div>

      <div class="school-class-compare-block-trophies__class-content">
        <ng-container *ngIf="classData.completedTrophiesNumber > 0; else emptyState">
          <div class="school-class-compare-block-trophies__class-trophies">
            <ng-container *ngFor="let trophyItem of classData.trophies">
              <div class="school-class-compare-block-trophies__class-trophy-item" *ngIf="trophyItem.progress === 100">
                <brt-trophy-icon [trophy]="trophyItem" [completed]="true"></brt-trophy-icon>
              </div>

            </ng-container>
          </div>

        </ng-container>
        <ng-template #emptyState>
          <div class="school-class-compare-block-trophies__class-trophy-empty">
            <brt-icon [icon]="'trophy'"></brt-icon>
            <span>{{"TEACHER_DASHBOARD.DASHBOARD_MENU.TROPHIES_TEXT" | translate}}</span>
          </div>
        </ng-template>

      </div>
    </div>
  </div>

</div>
